<!-- @format -->

<div
	id="plp-srlp-product-list-header"
	class="hmf-mx-s">
	<!-- breadcrumbs and header -->
	@if (productListSEOData()) {
		<div
			class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-justify-content-center">
			<plp-components-breadcrumb
				class="plp-breadcrumb hmf-body-m hmf-display-flex hmf-pt-m-m hmf-pt-s hmf-pb-xs">
			</plp-components-breadcrumb>
			@if (productListData()) {
				<h1
					class="heading hmf-header-bold-m hmf-header-bold-lg-l hmf-my-0"
					[class.hmf-pb-s]="!(displayBubbles().length) || isPlp3Template()">
					{{ productListSEOData()?.name }}
				</h1>
			} @else {
				<ng-container *ngTemplateOutlet="apiErrorMessage"></ng-container>
			}
		</div>
	} @else {
		<div>
			<plp-components-breadcrumb
				class="plp-breadcrumb hmf-body-m hmf-display-flex hmf-pt-s hmf-pt-m-m hmf-pb-xs"
				[searchTerm]="productListData()?.searchVO?.searchTerm || ''"
				[isSearchPage]="true">
			</plp-components-breadcrumb>
			@if (productListData()) {
				<div>
					<h1
						class="heading hmf-display-flex hmf-header-bold-m hmf-header-bold-m-l hmf-my-0"
						[class]="
							productListData()?.didYouMeanVO?.originalSearchTerm
								? 'hmf-mb-xs hmf-mb-m-s'
								: 'hmf-mb-s hmf-mb-m-m'
						">
						{{ searchResultsText().title }}
					</h1>
					@if (searchResultsText().subtext) {
						<p class="search-msg hmf-mb-s hmf-mb-m-m hmf-body-m">
							{{ searchResultsText().subtext }}
						</p>
					}
					@if (productListData()?.didYouMeanVO && !productListData()?.mlBypass) {
						<p class="search-msg hmf-mb-s hmf-mb-m-m hmf-body-m">
							Search instead for
							<button
								hmf-action-text
								variant="secondary"
								(click)="searchInstead()">
								{{ productListData()?.didYouMeanVO?.originalSearchTerm }}
							</button>
						</p>
					}
					@if (searchResultsText().zeroResults) {
						<div class="no-results-msg hmf-mb-s hmf-mb-m-m hmf-subheader-s">
							<p>{{ zeroResultsText.message }}</p>
							<p>{{ zeroResultsText.suggestion }}</p>
						</div>
					}
				</div>
			} @else {
				<ng-container *ngTemplateOutlet="apiErrorMessage"></ng-container>
			}
		</div>
	}
</div>

<ng-template #apiErrorMessage>
	<div class="heading hmf-display-flex hmf-header-bold-m hmf-header-bold-m-l hmf-my-0">
		<p>Something went wrong. Please try again.</p>
	</div>
</ng-template>
@if (narrowBanner()) {
	<shared-components-google-ad-manager
		[data]="'top_narrow_banner'"
		[showSponsoredLabel]="true"
		[enableAdCarousel]="isEvergreenContentEnabled()"
		[isNarrowBanner]="true"
		[pageType]="pageType()"
		[hasTopMargin]="false"
		[enableTooltipSurvey]="enableTooltipSurvey()">
	</shared-components-google-ad-manager>
}

<!-- superfamily bubbles -->
@if (displayBubbles().length) {
	<div
		id="superfamily-bubbles-container"
		class="superfamily-bubbles-container hmf-align-items-center hmf-display-flex hmf-justify-content-center hmf-mt-s hmf-position-relative">
		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
			[class.hmf-display-block]="showLeftArrow()"
			[previous]="true"
			[ariaLabel]="'Previous Category'"
			[showLeftArrow]="showLeftArrow()"
			(clickEvent)="clickBubblesCarouselButton($event)">
		</shared-components-carousel-button>
		<div
			#bubbleWrapper
			id="bubbles-wrapper"
			class="bubble-container hmf-display-flex hmf-pb-xxs hmf-px-s hmf-px-md-m hmf-pb-md-xs bubbles-wrapper-content-center"
			(scroll)="recalculateArrows()">
			@for (bubble of displayBubbles(); track $index + bubble.name) {
				<plp-components-category-bubble
					[image]="bubble.imgSrc || ''"
					[link]="bubble.url"
					[altText]="bubble.name"
					[label]="bubble.name"
					[attr.data-em]="bubble.dataEmAttr">
				</plp-components-category-bubble>
			}
		</div>
		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
			[class.hmf-display-block]="showRightArrow()"
			[previous]="false"
			[ariaLabel]="'Next Category'"
			[showRightArrow]="showRightArrow()"
			(clickEvent)="clickBubblesCarouselButton($event)">
		</shared-components-carousel-button>
	</div>
}
